/********************************************************************************* */
// rajanaresh.p@gmail.com google sheet APPS Script is below
// https://script.google.com/macros/s/AKfycbxj-Yp_QpNJY76Ev8DvlYVViWvlkIUbqYBZqdI7OlMEOVK4rt38zRckqdpuKPy-yxce/exec

// contactthemortgageist@gmail.com google sheet APPS Script is below
//https://script.google.com/macros/s/AKfycbyN6-FojYAWnIjqPynDwy8LTAuptWmNLRL-VLHUVE4Vqu6gHDb-b5yMwhTsBB6KkyJZyA/exec

import React, { useEffect, useState } from "react";
// import { useEffect, useState } from "react";
import MortgageRateTable from "../TableDataFormGoogeSheet/rateTable";
import TodayImage from "../../PicesForPages/360_F_852468013_NdDXatTPIV8K0Q5JBixO5PkfTZ1tjJKk3.webp";

import * as XLSX from "xlsx";

function TodaysRates() {
  const [data, setData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState("");
  const [loading, setLoading] = useState(true);

  // // it is from Google sheet and App Script, data shows some time
  // useEffect(() => {
  //   fetch(
  //     "https://script.google.com/macros/s/AKfycbyN6-FojYAWnIjqPynDwy8LTAuptWmNLRL-VLHUVE4Vqu6gHDb-b5yMwhTsBB6KkyJZyA/exec"
  //   )
  //     .then((res) => res.json())
  //     .then((json) => {
  //       const dateRow = json.find((row) => row.Type === "Last Updated Date");
  //       if (dateRow && dateRow["Home Value"]) {
  //         setLastUpdated(dateRow["Home Value"]);
  //       }

  //       const filteredData = json.filter(
  //         (row) => row.Type !== "Last Updated Date"
  //       );
  //       setData(filteredData);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error("Failed to fetch data:", err);
  //       setLoading(false);
  //     });
  // }, []);

  // it is from .XLSX Online sheet, data shows very fast
  useEffect(() => {
    const fetchXlsx = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          "https://docs.google.com/spreadsheets/d/1kCzJ0srQxCzK8fnnk31CiQ4imIiURr_7/export?format=xlsx&gid=1212840841",
        );
        const arrayBuffer = await res.arrayBuffer();

        // Read the Excel file
        const workbook = XLSX.read(arrayBuffer, { type: "array" });

        // Get first sheet name or specific sheet by name if you want
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convert sheet to JSON (array of objects)
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          defval: "",
          raw: false, // Ensures "June 26, 2025" is not turned into 45834
        });

        // Your existing logic to parse jsonData and set lastUpdated, filter etc.
        const dateRow = jsonData.find(
          (row) => row.Type === "Last Updated Date",
        );

        if (dateRow && dateRow["Home Value"]) {
          setLastUpdated(dateRow["Home Value"]);
        }

        const filteredData = jsonData.filter(
          (row) => row.Type !== "Last Updated Date",
        );
        setData(filteredData);
      } catch (err) {
        console.error("Failed to fetch or parse xlsx:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchXlsx();
  }, []);

  return (
    <div className="homeParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={TodayImage}
          alt="RFamilyImage"
          className="background-video"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Todays Rates</span>
        </div>
      </div>

      <div className="welcomeBoxParent">
        <div className="welcomeBox">
          <span className="welcomeHeading">
            Welcome to <span className="logoBoldColor">The Mortgageist</span>
          </span>
          <span className="welcomeContent todaysRatesContent">
            {/* <span className="todaysRatesContentContactNo">
              PLEASE CALL (610) 618-0618 FOR YOUR PERSONALIZED MORTGAGE INTEREST
              RATE.
            </span> */}
            <span className="todaysRatesContentCurrentDate">
              Rates effective as of{" "}
              {loading ? <span className="spinner" /> : lastUpdated || "N/A"}.
              These rates are indicative for Pennsylvania only.
            </span>
            <span className="todaysRatesContentSize">
              <span className="logoBoldColor">The Mortgageist</span> is a broker
              and only arranges your loans. Please note the rates given below
              are indicative and can change without notice. The interest rate is
              dependent on multiple factors.*
            </span>
          </span>

          <MortgageRateTable data={data} loading={loading} />

          <span className="welcomeContent todaysRatesContent todaysRatesContent00">
            <span className="todaysRatesContentOL todaysRatesContentSize">
              <span className="todaysRatesContentOLHeading">
                * Factors that can change the rate are
              </span>
              Equity in home, Loan Amount, Loan Term, Credit Score, Location of
              the home and PUD or Condo
            </span>
            <span className="todaysRatesContentSize">
              This estimate is provided for illustrative and informational
              purposes only based on the basic loan scenario provided. This is
              not a loan approval or commitment to lend. and are subject to
              change. Annual Percentage Rate (APR) is an estimate based on
              criteria provided. Until you lock your rate, APR and terms are
              subject to change or may not be available at commitment or
              closing.*
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default TodaysRates;
